import { render, staticRenderFns } from "./nav-user.vue?vue&type=template&id=3678b169&scoped=true&"
import script from "./nav-user.vue?vue&type=script&lang=js&"
export * from "./nav-user.vue?vue&type=script&lang=js&"
import style0 from "./nav-user.vue?vue&type=style&index=0&id=3678b169&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678b169",
  null
  
)

export default component.exports